import './upload-step.scss';
import React, { useEffect } from 'react'
import { Typography, Button, FilePicker } from '@weirgroup/weir-dls'
import { useTranslation } from 'react-i18next'
import { useAnalyticsEvent } from '../../../../hooks/useAnalyticsEvent';

interface UploadStepProps {
    darkMode: boolean;
    selectedFile: File | null;
    onFileSelect: (files: File[] | null) => void;
    onNext: () => void;
    onPrev: () => void;
    errorMessage?: string | null;
    isValidating?: boolean;
}


const UploadStep: React.FC<UploadStepProps> = (props) => {
    const logAnalyticsEvent = useAnalyticsEvent();
    const { darkMode, selectedFile, onFileSelect, onNext, onPrev, errorMessage, isValidating } = props;
    const { t } = useTranslation();
    const fileNameDisplay = selectedFile ? selectedFile.name : null;
    // Only disable if no file or errorMessage (which is only set for file type/selection errors)
    const isButtonDisabled = !selectedFile || !!errorMessage || isValidating;
     useEffect(() => {
            logAnalyticsEvent('web_user_viewed_upload_step', { description: 'User viewed the upload step in upload assets' });
        },[]);
    return (
        <>
            <Typography
                variant="P1"
                color={darkMode ? "white" : "black"}
                className="step-instruction"
            >
                {t('uploadAssets.uploadStep.description')}
            </Typography>

            {fileNameDisplay && (
                <div className={`selected-file-info${darkMode ? ' dark-mode' : ''}`}>
                    {t('uploadAssets.uploadStep.selectedFile', 'Selected file')}: {fileNameDisplay}
                </div>
            )}

            {
                !isValidating && (
                    <div className="file-picker-section">
                        <FilePicker
                            darkMode={darkMode}
                            errorMessage={errorMessage || ""}
                            fileTypeHintInfo={t('uploadAssets.uploadStep.fileTypeHint')}
                            fileTypeHintShow
                            modalType="large"
                            onFileSelect={onFileSelect}
                            outerContainerPadding="15px 0 180px 15px"
                            multiple={false}
                        />
                    </div>
                )
            }

            <div className="upload-button-section">
                <Button
                    darkMode={darkMode}
                    label={t('uploadAssets.buttons.prev', 'Prev')}
                    size="md"
                    variant="secondary"
                    onClick={onPrev}
                    disabled={isValidating}
                />
                <Button
                    darkMode={darkMode}
                    label={
                        isValidating ? (
                            <div className="button-validating-label">
                                <span className="button-spinner"></span>
                                {t('uploadAssets.buttons.validating', 'Validating...')}
                            </div>
                        ) : (
                            t('uploadAssets.buttons.uploadFile')
                        )
                    }
                    size="md"
                    variant="primary"
                    onClick={onNext}
                    disabled={isButtonDisabled}
                />
            </div>
        </>
    )
}

export default UploadStep;
